module.exports = __webpack_public_path__ + "img/a34.755991a7.svg";